import { useState } from "react";

export const useActivePage = ({ pageName = "personalInfo" }) => {
	const [activePage, setActivePage] = useState(pageName);
	return {
		activePage,
		setActivePage,
	};
};
